function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M59.88 54.29S62.61 39.68 80 39.76s23.27 21.42 14.1 30.75C90 74.7 86.49 78.15 84 80.57a13.39 13.39 0 00-4 9.57v7.73"
});

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 80,
  cy: 80,
  r: 76
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 80,
  cy: 120,
  r: 2
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 80,
  cy: 120,
  r: 1
});

var SvgHelp = function SvgHelp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "ICON",
    viewBox: "0 0 160 160",
    "aria-hidden": true
  }, props), _ref, _ref2, _ref3, _ref4);
};

export default SvgHelp;